import React from 'react';
import TopSuppliersChart from './top_suppliers_chart';
import ExpiryTimelineChart from './expiry_timeline_chart';
import StockStatusDonutChart from './stock_status_donut_chart';
import NonMedicalCategoryPieChart from './non_medical_category_pie_chart';
import InventoryTrendLineChart from './inventory_trend_line_chart';
import { CategoryWiseDistribution, ExpiryRiskTimeline, InventoryValueTrend, StockStatusDistribution, TopSupplier } from '@/gen/inventory/common_pb';
import { StockStatusSplit } from '../../-data/model';

interface AnalyticsProps {
  topSuppliers: TopSupplier[];
  expiryTimeline: ExpiryRiskTimeline[];
  stockStatusSplit: StockStatusDistribution[];
  nonMedicalCategoryDistribution: CategoryWiseDistribution[];
  inventoryTrend: InventoryValueTrend[];
}

const Analytics: React.FC<AnalyticsProps> = ({ topSuppliers, expiryTimeline, stockStatusSplit, nonMedicalCategoryDistribution, inventoryTrend }) => {
  return (
    <>
      <p className='text-xl font-semibold text-gray-600'>Analytics</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2 max-h-[400px] h-full">
          <InventoryTrendLineChart data={inventoryTrend} />
        </div>
        <div className="max-h-[400px] h-full">
          <StockStatusDonutChart stockStatusSplit={stockStatusSplit} />
        </div>
        <div className="max-h-[500px] h-full">
          <TopSuppliersChart topSuppliers={topSuppliers} />
        </div>
        <div className="max-h-[500px] h-full">
          <ExpiryTimelineChart expiryTimeline={expiryTimeline} />
        </div>
        <div className="max-h-[500px] h-full">
          <NonMedicalCategoryPieChart data={nonMedicalCategoryDistribution} />
        </div>
      </div>
    </>
  );
};

export default Analytics;